import { Modal } from '@douyinfe/semi-ui';

interface IProps {
  visible: boolean,
  onCancel?: () => void
}

const TicketModal = ({ visible, onCancel }: IProps) => {
  return (
    <div className='ticket-modal'>
      <Modal visible={visible} centered onCancel={onCancel}>
        <img src="https://img.cbcechina.com/2024-12-10/55680c07f06418fb99396fbc289442e3.png" alt="" />
      </Modal>
      <style jsx global>
        {
          `
            .semi-modal-content{
              background-color: transparent;
              border: none;
              border-radius: 0;
              box-shadow: none;
              padding: 0;
              overflow: visible;
            }
            .semi-modal-body-wrapper{
              padding: 0 20px;
              margin: 0;
            }
            .semi-modal-close{
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
              width: 30px;
              height: 30px;
              background-color: rgb(255, 255, 255, 0.4) !important;
              border-radius: 50%;
              color: #ffffff !important;
            }
            .semi-modal-footer{
              display: none;  
            }
          `
        }
      </style>
    </div>
  )
}

export default TicketModal